import React, { useEffect, useState } from 'react';
import './login.css';
import { Navigate } from 'react-router-dom';
import { useAuthenticate } from '../../hooks';
import { DASHBOARD_PATH } from '../../router/RouteConstants';
import Header from '../../layout/Header/Header';
import AIEduButton from '../../components/Button/AIEduButton';
import googleIcon from '../../assets/images/google_colored_login.svg';
import microsoftIcon from '../../assets/images/microsoft_colored_login.svg';
import { useIntl } from 'react-intl';
import { API } from '../../services';
import { APP_VERSION } from '../../utils/Constants';

const Login = () => {
    const intl = useIntl();
    const { formatMessage: f } = intl;
    const { auth } = useAuthenticate();

    const [termUrl, setTermUrl] = useState(null);
    const [policyUrl, setPolicyUrl] = useState(null);
    const [cookiePolicyUrl, setCookiePolicyUrl] = useState(null);

    if (auth) {
        return <Navigate to={DASHBOARD_PATH} />;
    }

    useEffect(() => {
        if (auth) {
            return;
        }

        API.getTermsAndPolicy('orgId').then(({ data }) => {
            const { terms } = data;
            setTermUrl(terms?.[0]?.termUrl);
            setPolicyUrl(terms?.[1]?.termUrl);
            setCookiePolicyUrl(terms?.[2]?.termUrl);
        });
    }, []);

    const LOGIN_URL =
        process.env.REACT_APP_AI_ASSISTANCE_HOST + '/ums/auth/login';

    const handleSignInBtnClick = (e) => {
        const { name } = e.target;
        window.location.replace(`${LOGIN_URL}?idp=${name}`);
    };

    const SignInButtonStyle = ({ idp, text, icon, handleClick, btnStyle }) => {
        return (
            <AIEduButton
                name={idp}
                className={btnStyle}
                label={
                    <div className='flex'>
                        <div className='account_logo'>
                            <img src={icon} />
                        </div>
                        <div className='flex align-items-center'>{text}</div>
                    </div>
                }
                onClick={handleClick}
            />
        );
    };

    const signInBtns = [
        {
            idp: 'samsung',
            text: f({ id: 'AI_EDU_CONTINUE_WITH_SAMSUNG' }),
            icon: null,
        },
        {
            idp: 'google',
            text: f({ id: 'AI_EDU_CONTINUE_WITH_GOOGLE' }),
            icon: googleIcon,
        },
        {
            idp: 'microsoft',
            text: f({ id: 'AI_EDU_CONTINUE_WITH_MICROSOFT' }),
            icon: microsoftIcon,
        },
    ];

    const handleNavigation = (url) => {
        if (!url) return;
        window.open(url, '_blank');
    };

    return (
        <div className='page-layout'>
            <Header isLoginPage={true} />
            <main className='login'>
                <div className='main'>
                    <div className='main-header'>
                        {f({ id: 'AI_EDU_SIGN_IN' })}
                    </div>
                    <div className='login-text'>
                        {f({
                            id: 'AI_EDU_GET_STARTED_WITH_SAMSUNG_AI_ASSISTANT',
                        })}
                    </div>
                    <div className='signin-options'>
                        {signInBtns.map(({ idp, text, icon }) => (
                            <SignInButtonStyle
                                idp={idp}
                                text={text}
                                icon={icon}
                                btnStyle='btnPrimary'
                                handleClick={handleSignInBtnClick}
                            />
                        ))}
                    </div>
                </div>
            </main>
            <footer className='footer'>
                <div>
                    {f({ id: 'AI_EDU_SERVER_VERSION' })} {APP_VERSION}
                </div>
                <div
                    onClick={() => handleNavigation(termUrl)}
                    className='cursor-pointer hover:underline'
                >
                    {f({ id: 'AI_EDU_TERMS_AND_CONDITION' })}
                </div>
                <div
                    onClick={() => handleNavigation(policyUrl)}
                    className='cursor-pointer hover:underline'
                >
                    {f({ id: 'AI_EDU_PRIVACY_POLICY' })}
                </div>
                <div
                    onClick={() => handleNavigation(cookiePolicyUrl)}
                    className='cursor-pointer hover:underline'
                >
                    {f({ id: 'AI_EDU_COOKIE_POLICY' })}
                </div>
                    <div>
                        {f({ id: 'AI_EDU_COPYRIGHT_TEXT' })}
                    </div>
            </footer>
        </div>
    );
};

export default Login;
